import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Input,
  Button,
  Space,
  message,
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";

const ParamEditModal = forwardRef(({ record, paramEditModalSubmitlFn}, ref) => {
    const [form] = Form.useForm();
    const [modalFlag, setModalFlag] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [GLAcctList, setGLAcctList] = useState([]);
    
    useImperativeHandle(ref, () => ({
      openModal: () => {
        setModalFlag(true)
      }
    }));

    const glAcctListFn = async() => {
      const response = await http.get(api.gardenerGLAccountList);
      setGLAcctList(response?.data || [])
    }

    useEffect(() => {
      if(modalFlag){
        glAcctListFn()
        form.setFieldsValue({
          ...record,
          payAmount: record?.payAmount || record?.quotedAmount
        })
      }
      return () => {
        setBtnLoading(false)
        form.resetFields();
      }
    }, [modalFlag])

    const submitFn = async() => {
      setBtnLoading(true)
      const params = {
        ...form.getFieldsValue(),
        id: record.id
      }
      const response = await http.post(api.updateGlAcctAndStatusToInfo, params);
      if(response.code === '1'){
        message.success("Modify Successfully.");
        setModalFlag(false)
        paramEditModalSubmitlFn()
      }else{
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold"}}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          Modify Info
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      destroyOnClose={true}
      width="80%"
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{span: 8}}
        wrapperCol={{span: 16}}
        labelWrap={true}
        labelAlign="right"
        initialValues={{
          isPay: false,
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={12} offset={6}>
            <Form.Item
              name="requestNo"
              label="Request No"
            >
              <Input
                disabled
                placeholder="Request No will appear here"
              />
            </Form.Item>
            <Form.Item
              name="glAcct"
              label="GL Acct"
            >
              <Select
                showSearch
                allowClear
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.glAcctTitle ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  value: "glAcct",
                  label: "glAcctTitle",
                }}
                options={GLAcctList}
              />
            </Form.Item>

            {commonFn.formInputNumberDoc({
              name: "payAmount",
              label: "Payment Amount",
              form: form,
              isNoRequired: true,
            })}

            <Form.Item
              name="payRemark"
              label="Payment Remark"
            >
              <Input.TextArea placeholder="Enter payment remark (optional)" />
            </Form.Item>

            <Form.Item
              name="isPay"
              label="Pay?"
            >
              <Select
                options={[
                  {label: 'Do Not Pay', value: true},
                  {label: 'Allow To Pay', value: false},
                ]}
              />
            </Form.Item>

          </Col>
        </Row>
      </Form>
      <div style={{textAlign:'center'}}>
        <Space align="center">
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => submitFn()} loading={btnLoading}>
            Submit
          </Button>
        </Space>
      </div>
    </Modal>
    
  );
});

export default ParamEditModal;